import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const LegalLayout = lazy(() =>
  import('../pages/legal/LegalLayout').then((m) => ({ default: m.default }))
)
const LegalHubPage = lazy(() =>
  import('../pages/legal/LegalHubPage').then((m) => ({ default: m.default }))
)
const PrivacyPolicyPage = lazy(() =>
  import('../pages/legal/PrivacyPolicyPage').then((m) => ({ default: m.default }))
)
const TermsOfServicePage = lazy(() =>
  import('../pages/legal/TermsOfServicePage').then((m) => ({ default: m.default }))
)
const CookiePolicyPage = lazy(() =>
  import('../pages/legal/CookiePolicyPage').then((m) => ({ default: m.default }))
)
const GDPRCompliancePage = lazy(() =>
  import('../pages/legal/GDPRCompliancePage').then((m) => ({ default: m.default }))
)
const DPAPage = lazy(() =>
  import('../pages/legal/DPAPage').then((m) => ({ default: m.default }))
)
const SecurityPolicyPage = lazy(() =>
  import('../pages/legal/SecurityPolicyPage').then((m) => ({ default: m.default }))
)
const AccessibilityPage = lazy(() =>
  import('../pages/legal/AccessibilityPage').then((m) => ({ default: m.default }))
)
const AcceptableUsePage = lazy(() =>
  import('../pages/legal/AcceptableUsePage').then((m) => ({ default: m.default }))
)
const DisclaimerPage = lazy(() =>
  import('../pages/legal/DisclaimerPage').then((m) => ({ default: m.default }))
)

export const legalRoutes: RouteObject[] = [
  {
    path: 'legal',
    element: <LegalLayout />,
    children: [
      { index: true, element: <LegalHubPage /> },
      { path: 'privacy', element: <PrivacyPolicyPage /> },
      { path: 'terms', element: <TermsOfServicePage /> },
      { path: 'cookies', element: <CookiePolicyPage /> },
      { path: 'gdpr', element: <GDPRCompliancePage /> },
      { path: 'dpa', element: <DPAPage /> },
      { path: 'security', element: <SecurityPolicyPage /> },
      { path: 'accessibility', element: <AccessibilityPage /> },
      { path: 'acceptable-use', element: <AcceptableUsePage /> },
      { path: 'disclaimer', element: <DisclaimerPage /> },
    ],
  },
]
